import { render, staticRenderFns } from "./SpuTx.vue?vue&type=template&id=5b1b470a&scoped=true&"
import script from "./SpuTx.vue?vue&type=script&lang=js&"
export * from "./SpuTx.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1b470a",
  null
  
)

export default component.exports